import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
	{
		path: "/",
		name: "home",
		component: async () => await import("@/views/home/home.vue"),
		meta: { title: "", keepAlive: true, hiddenWrap: true },
	},
];
// app router
export const router = createRouter({
	// 解决 二级路径存在时，路径地址路由不匹配的问题
	// https://juejin.cn/post/7051826951463370760#heading-27
	history: createWebHistory(),
	routes,
	strict: true,
	scrollBehavior: () => ({ left: 0, top: 0 }),
});
